import { Activity } from "../../context/Prestudy/Activity";
import { usePrestudyContext } from "../../context/Prestudy/PrestudyContextProvider";
import { Text, VStack } from "@chakra-ui/layout";
import { English } from "../../Texts";
import { SPACING } from "../../constants/Constants";
import { Tag, TagCloseButton } from "@chakra-ui/tag";

export default function ActivityCard({ activity }: { activity: Activity }) {
    const { removeActivity } = usePrestudyContext().activityContext;
    const texts = English.prestudySplitter;
    return (
        <Tag py={SPACING / 5} colorScheme="gray" h={SPACING}>
            <VStack mx={SPACING / 4}>
                <Text mb={-SPACING / 4}>{texts.labels.activityNumberShort}</Text>
                <Text>{activity.number}</Text>
            </VStack>
            <VStack mx={SPACING / 4}>
                <Text mb={-SPACING / 4}>{texts.labels.duration}</Text>
                <Text>{activity.duration} {texts.labels.minutes}</Text>
            </VStack>
            <TagCloseButton onClick={() => removeActivity(activity.number)} fontSize={25} />
        </Tag>
    );
}